import { Text, View } from 'react-native'

import { convertLineHeight, styled } from '~/utils'

export const Root = styled(View, theme => {
  return {
    base: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      alignContent: 'center',
      justifyContent: 'flex-start',
      gap: theme.spacingInlineHalfpulse,
    },
    variants: {},
  }
})

export const Label = styled(Text, theme => {
  return {
    base: {
      color: theme.colorTextDangerAlternative,
      fontFamily: theme.fontFamily.semiBold,
      fontSize: theme.fontSizeThreepulse,
      paddingLeft: theme.spacingInlineOnepulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightDefault
      ),
      textAlign: 'left',
      textAlignVertical: 'top',
    },
    variants: {},
  }
})
